import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useStaff } from "../../../../Logic/Preference/useStaff";
import { useAddNewFolder } from "../../../../Logic/useAddNewFolder";
import CommonModal from "../../../Modals/CommonModal";
import AddStaff from "../../PreferenceList/Components/AddStaff";
import { FormFields } from "./FormFields";

export const AddNewFolderModal = ({
  setAddNewProjectPopup,
  addNewProjectPopup,
  handleSubmitCreateNewFolder,
  isEventEdit,
  currentTab,
}) => {
  const dispatch = useDispatch();
  const { designations, section } = useSelector((state) => state.staffs);
  const { createNewFolder, allFolders, eventModalData } = useSelector(
    (state) => state.projectSinglePage
  );
  const {
    staffSubmit,
    staffValidationSchema,
    setCustomDesignation,
    handleAddStaff,
    showAddStaffModal,
    setShowAddStaffModal,
    customDesignation,
  } = useStaff(setAddNewProjectPopup);
  const { handleSaveEventCreateModalData, handleClearEventCreateData } =
    useAddNewFolder();

  return (
    <>
      <CommonModal
        backdrop="static"
        keyboard={false}
        showModal={addNewProjectPopup}
        setShowModal={() => {
          setAddNewProjectPopup(false);
          handleClearEventCreateData();
        }}
        centered={true}
        className={"create-project-modal"}
        title={
          isEventEdit === false && isEventEdit !== undefined ? (
            <h4>Create Event</h4>
          ) : (
            <h4>Edit Event</h4>
          )
        }
        content={
          <FormFields
            isEdit={isEventEdit === true && isEventEdit !== undefined}
            handleSubmitCreateNewFolder={handleSubmitCreateNewFolder}
            handleCancel={setAddNewProjectPopup}
            handleStaffModal={handleAddStaff}
            currentTab={currentTab}
            noStaffs={createNewFolder?.staffList?.length === 0}
          />
        }
      />
      <AddStaff
        showAddStaffModal={showAddStaffModal}
        setShowAddStaffModal={setShowAddStaffModal}
        showEventModal={setAddNewProjectPopup}
        customDesignation={customDesignation}
        designations={designations}
        staffSubmit={staffSubmit}
        setCustomDesignation={setCustomDesignation}
        handleStaffModal={handleAddStaff}
        staffValidationSchema={staffValidationSchema}
      />
    </>
  );
};
